<template>
  <div class="admin-content">
    <div class="content-main">
      <div class="main-filters">
        <div class="filter-list">
          <div class="filter-item">
            <span class="title">Content:</span>
            <el-input class="content" placeholder="Search by content" v-model="filter.content" size="small" clearable @change="changeFilter"></el-input>
          </div>
          <div class="filter-item">
            <span class="title">Feature: </span>
            <el-select class="content" size="small" v-model="filter.feature" placeholder="Search by feature" @change="changeFilter">
              <el-option key="0" label="All" value=""></el-option>
              <el-option key="1" label="Gear" :value="0"></el-option>
              <el-option key="2" label="Blind" :value="1"></el-option>
              <el-option key="3" label="Share" :value="2"></el-option>
              <el-option key="4" label="ListeningGuide" :value="3"></el-option>
              <el-option key="5" label="Discography" :value="4"></el-option>
              <el-option key="6" label="FrequencyOrTech" :value="5"></el-option>
              <el-option key="7" label="Image" :value="6"></el-option>
              <el-option key="8" label="BuyButton" :value="7"></el-option>
              <el-option key="9" label="AtkpAudio" :value="8"></el-option>
              <el-option key="9" label="AtkpWaveform" :value="9"></el-option>
            </el-select>
          </div>
        </div>
        <div class="filter-actions">
          <el-button class="el-btn-blue" size="small" @click="changeFilter">Search</el-button>
          <el-button class="action-reset" size="small" @click="resetFilter">Reset</el-button>
        </div>
      </div>
      <div class="main-actions">
        <el-button class="el-btn-blue" size="small" icon="el-icon-plus" @click="newTooltip()">New Tooltip</el-button>
      </div>
      <div class="main-table">
        <el-table :data="tooltips" v-loading="flagLoading.getTooltips" border>
          <el-table-column type="index" label="#" :index="generateIndex" width="100" />
          <el-table-column label="Feature">
            <template #default="scope">
              <span>{{ generateFeature(scope.row.feature) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="Content" />
          <el-table-column label="Created at">
            <template #default="scope">
              <span>{{ generateTime(scope.row.created_at) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Last updated">
            <template #default="scope">
              <span>{{ generateTime(scope.row.updated_at) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Operate">
            <template #default="scope">
              <div class="table-operate">
                <div class="operate-item">
                  <el-button size="small" type="text" class="el-btn-blue" @click="editTootip(scope.row)">Edit</el-button>
                </div>
                <div class="operate-item">
                  <el-popconfirm
                    title="Confirm to delete this record?"
                    @confirm="deleteTooltip(scope.row)"
                  >
                    <template #reference>
                      <el-button size="small" type="text" class="el-btn-blue">Delete</el-button>
                    </template>
                  </el-popconfirm>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="common-pagination" background layout="prev, pager, next"
          :current-page="pageNum" :page-size="pageSize" :total="totalNum"
          @current-change="changeCurrentPage"
        />
      </div>
    </div>
    <ModalTooltip
      v-bind:flagVisible="flagVisible.modalTooltip" v-on:closeModal="flagVisible.modalTooltip = false"
      v-bind:actionItem="actionItems.tooltip" v-on:reloadData="reloadData"
    />
  </div>
</template>

<script>
import { reactive } from 'vue'
import moment from 'moment'
import ModalTooltip from './modals/Tooltip.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'GlobalTooltips',
  components: {
    ModalTooltip
  },
  data () {
    const filter = reactive({
      content: '',
      feature: ''
    })
    const flagLoading = reactive({
      getTooltips: false
    })
    const flagVisible = reactive({
      modalTooltip: false
    })
    const actionItems = reactive({
      tooltip: {
        _id: '',
        content: '',
        feature: ''
      }
    })
    return {
      tooltips: [],
      pageNum: 1,
      pageSize: 20,
      totalNum: 0,
      filter,
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created: function () {
    this.getTooltips()
  },
  mounted () {
  },
  computed: {
    ...mapGetters({
      currentRole: 'currentRole'
    })
  },
  watch: {
  },
  methods: {
    getTooltips: function () {
      this.flagLoading.getTooltips = true
      const { pageNum, pageSize, filter } = this
      let url = `/api/v1/atk_player/admin/tooltips?page_num=${pageNum}&page_size=${pageSize}&is_deleted=false`
      if (filter.content) url += `&content=${encodeURIComponent(filter.content)}`
      if (filter.feature || filter.feature === 0) url += `&feature=${encodeURIComponent(filter.feature)}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.tooltips = res.data.list
          that.totalNum = res.data.total_num
        }
        that.flagLoading.getTooltips = false
      }).catch(function (err) {
        console.error('getTooltips', err)
        that.flagLoading.getTooltips = false
      })
    },
    generateTime: function (time) {
      const tz = moment().utcOffset()
      return moment(time).utcOffset(tz).format('D MMM YYYY HH:mm')
    },
    generateFeature: function (feature) {
      let str = ''
      switch (`${feature}`) {
        case '9':
          str = 'AtkpWaveform'
          break
        case '8':
          str = 'AtkpAudio'
          break
        case '7':
          str = 'BuyButton'
          break
        case '6':
          str = 'Image'
          break
        case '5':
          str = 'FrequencyOrTech'
          break
        case '4':
          str = 'Discography'
          break
        case '3':
          str = 'ListeningGuide'
          break
        case '2':
          str = 'Share'
          break
        case '1':
          str = 'Blind'
          break
        case '0':
          str = 'Gear'
          break
      }
      return str
    },
    changeCurrentPage: function (page) {
      this.pageNum = page
      this.getTooltips()
    },
    changeFilter: function () {
      this.pageNum = 1
      this.getTooltips()
    },
    resetFilter: function () {
      this.filter = { name: '' }
      this.pageNum = 1
      this.getTooltips()
    },
    generateIndex: function (index) {
      const { pageNum, pageSize } = this
      return index + 1 + pageSize * (pageNum - 1)
    },
    newTooltip: function () {
      const actionTooltip = this.actionItems.tooltip
      if (actionTooltip._id) {
        this.actionItems.tooltip = {
          _id: '',
          content: '',
          feature: ''
        }
      }
      this.flagVisible.modalTooltip = true
    },
    editTootip: function (tooltip) {
      console.log('tooltip')
      console.log(tooltip)
      console.log('tooltip')
      const actionTooltip = this.actionItems.tooltip
      if (actionTooltip._id !== tooltip._id) {
        this.actionItems.tooltip = { ...tooltip }
      }
      this.flagVisible.modalTooltip = true
    },
    reloadData: function () {
      this.actionItems.tooltip = {
        _id: '',
        content: '',
        feature: ''
      }
      this.getTooltips()
    },
    deleteTooltip: function (tooltip) {
      const url = `/api/v1/atk_player/admin/tooltips/${tooltip._id}`
      const that = this
      this.$service.delete(url).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Delete success' })
          that.getTooltips()
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
      }).catch(function (err) {
        console.error('deleteTooltip', err)
      })
    }
  }
}
</script>
